export const model = {
    fields: {
        name: {
            isRequired: true
        },
        email: {
            isRequired: true,
            type: 'email'
        },
        vat: {
            isRequired: true
        },
        currency: {
            isRequired: true
        },
        countryCode: {
            isRequired:true
        }
    }
}